import React from "react";
import CategoryCard from "./CategoryCard";
import { Grid, Typography, Button } from "@mui/material";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";

function Categories({ category }) {
  return (
    <div>
      <Grid container gap={0} className="mt-1 flex items-center justify-center">
        <Grid item md={3} sx={{ height: { md: "500px" }, padding: "10px" }}>
          <Typography variant="h2">
            <bold>Categories</bold>
          </Typography>
          Our categories,...
        </Grid>
        <CategoryCard
          src={"category/shoes"}
          category="Shoes"
          image="Images/Shoes.jpg"
          sx={{ borderRight: { md: 3 }, borderLeft: { md: 3 } }}
        />
        <CategoryCard
          src={"category/hand_bags"}
          category="Hand Bags"
          image="Images/Handbags.jpg"
        />
      </Grid>
      <Grid container gap={0} className="flex items-center justify-center">
        <CategoryCard
          src={"category/purses"}
          category="Purses"
          image="Images/Purses.jpg"
          sx={{ borderTop: { md: 3 } }}
        />
        <CategoryCard
          src={"category/jewelry"}
          category="Jewelry"
          image="Images/Jewelry.jpg"
          sx={{
            borderTop: { md: 3 },
            borderRight: { md: 3 },
            borderLeft: { md: 3 },
          }}
        />
        <CategoryCard
          src={"category/used_bag_packs"}
          category="Used Bag Packs"
          image="Images/display/bags01.jpg"
          sx={{
            borderTop: { md: 3 },
          }}
        />
      </Grid>
    </div>
  );
}

export default Categories;
